import React from "react";
import { Button } from "@/components/ui/button";
import { SimpleColumnManager } from "../../SimpleColumnManager";
import { ControlsBarProps } from "../types";

/**
 * Controls bar component - export buttons and column manager
 */
export function ControlsBar({ data, onExport }: ControlsBarProps) {
  return (
    <div className="flex items-center justify-between gap-3 flex-wrap">
      {/* Export Buttons */}
      {onExport && (
        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onExport(data, "csv")}
            className="gap-2"
          >
            📥 Export CSV
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => onExport(data, "json")}
            className="gap-2"
          >
            📥 Export JSON
          </Button>
        </div>
      )}

      {/* Column Manager */}
      <div className="ml-auto">
        <SimpleColumnManager />
      </div>
    </div>
  );
}

// Made with Bob
